import React, { useRef } from "react";
import { useReactToPrint } from 'react-to-print';
import InDsQuyTienMat from "./InDsQuyTienMat";

const BtnInQuyTienMat = ({ data, dauKy, cuoiKy, dateFrom, dateTo, config }) => {
    const componentToPrintRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentToPrintRef.current,
    });

    return (
        <>
            <a 
                type="button" 
                className="btn"
                onClick={handlePrint}
                style={{ backgroundColor: "#006266", color: "white" }}
            >
                <i className="fas fa-print" style={{ marginRight: '5px'}}></i> 
                In phiếu
            </a>

            <div style={{ display: "none" }}>
                <InDsQuyTienMat
                    ref={componentToPrintRef}
                    data={data}
                    dauKy={dauKy}
                    cuoiKy={cuoiKy}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                    config={config}
                />
            </div>
        </>
    );
};

export default BtnInQuyTienMat;